<script lang="ts">
	import type { Snippet } from "svelte";
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import {
		teamDefaults,
		defaultMembers,
		type TeamBaseProps,
		type TeamMember
	} from "./team.types";

	type TeamBaseComponentProps = TeamBaseProps & {
		children: Snippet<
			[{ label?: string; title: string; subtitle?: string; members: TeamMember[] }]
		>;
	};

	let {
		theme = teamDefaults.theme,
		id = teamDefaults.id,
		label = teamDefaults.label,
		title = teamDefaults.title,
		subtitle = teamDefaults.subtitle,
		members = defaultMembers,
		children
	}: TeamBaseComponentProps = $props();
</script>

<Section {theme} {id}>
	{@render children({ label, title, subtitle, members })}
</Section>
